import React, { useState, useEffect } from 'react';

const ImageSlider = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isFading, setIsFading] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsFading(true);
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        setIsFading(false);
      }, 500); // Dužina fade-out efekta
    }, 7000); // Promena slike svakih 7 sekundi

    return () => clearInterval(interval);
  }, [images]);

  const goToPrevious = () => {
    setIsFading(true);
    setTimeout(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === 0 ? images.length - 1 : prevIndex - 1
      );
      setIsFading(false);
    }, 500);
  };

  const goToNext = () => {
    setIsFading(true);
    setTimeout(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
      setIsFading(false);
    }, 500);
  };

  return (
    <div className="slider-container">
      <div
        className={`slider-image ${isFading ? 'fade' : ''}`}
        style={{
          backgroundImage: `url(${images[currentIndex]})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '300px',
        }}
      />
      <button className="slider-arrow left" onClick={goToPrevious}>
        &#10094;
      </button>
      <button className="slider-arrow right" onClick={goToNext}>
        &#10095;
      </button>
    </div>
  );
};

export default ImageSlider;
